import './App.css';
import ugarticDelta from './images/ugartic_delta_upsidedown_transparent3.png'
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

// upd
function Temp() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
    <Helmet>
        <title>Dachrus</title>
        <meta name="description" content="Dachrus" />
        <meta property="og:description" content="Dachrus" />
        <meta property="og:title" content="Dachrus" />
        <meta name="twitter:description" content="Dachrus" />
        <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
      </Helmet>

    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        WebkitTouchCallout: 'none',
        WebkitUserSelect: 'none',
        KhtmlUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none'
      }}
      onTouchStart={(e) => e.preventDefault()}
      onTouchMove={(e) => e.preventDefault()}
    >
      <img
        src={ugarticDelta}
        alt=""
        style={{
          width: windowWidth < 400 ? '160px' : '220px',
          height: 'auto',
          objectFit: 'contain',
          userSelect: 'none',
          pointerEvents: 'none',
          WebkitTouchCallout: 'none',
          WebkitUserSelect: 'none',
          KhtmlUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
          touchAction: 'none'
        }}
        onContextMenu={(e) => e.preventDefault()}
        draggable={false}
      />
    </div>
    </>
  );
}

export default Temp;
